import type { GemKind, Piece, PieceCells } from '../core/types';

/**
 * Geometry, independent of color. Two cards can share a shape while placing
 * entirely different gems — that separation is what makes hands read as
 * "I have the shape but not the colors" rather than "same tool again."
 */
export interface ShapeDef {
  readonly id: string;
  readonly cells: PieceCells;
}

/** A color pattern, independent of geometry. */
export interface ColorRecipe {
  readonly id: string;
  readonly kinds: readonly GemKind[];
}

/** Bind a shape to a color recipe, producing a ready-to-drop piece. */
export function makePiece(shape: ShapeDef, recipe: ColorRecipe): Piece {
  return {
    cells: shape.cells,
    kinds: recipe.kinds,
  };
}
